export type ReleaseNote = {
    id: number
    title: string
    description: string
}

export const releaseNotes: ReleaseNote[] = [
    {
        id: 1,
        title: 'Manglende prøver og dokumentasjon',
        description:
            'Nå er det lettere å se hvilke pasienter som mangler prøver eller dokumentasjon. Skriv det som mangler i planleggingskommentaren og lagre de foreslåtte merknadene fra Hero.',
    },
]

export const latestReleaseNote = releaseNotes.at(-1) ?? null
